import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { QueryProvider } from './contexts/QueryProvider'
import { Navigation } from './components/Navigation'
import { Footer } from './components/Footer'
import { Landing } from './pages/Landing'
import { Shop } from './pages/Shop'
import { About } from './pages/About'
import { AuthForm } from './components/AuthForm'
import { ProfileManager } from './components/ProfileManager'
import './App.css'

const AppContent: React.FC = () => {
  // Set dark theme by default
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark')
  }, [])

  return (
    <div className="app">
      <Navigation />
      
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/about" element={<About />} />
          <Route path="/auth" element={<AuthForm />} />
          <Route path="/profile" element={<ProfileManager />} />
        </Routes>
      </main>
      
      <Footer />
    </div>
  )
}

function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </QueryProvider>
  )
}

export default App
